module.exports = __webpack_public_path__ + "img/crown_bg_liveflamingo.de625bf9.png";